import React from 'react'
import { Form, Loader } from 'stylist'
import withConnectionQuery from 'components/withConnectionQuery'
import graphqlQuery from 'graphs/queries/ProductsPaginated.graphql'
import displayName from 'utils/displayName'

const {
  Group,
  Label,
  Select,
  Select: { Option }
} = Form

const ProductSelect = ({ field, key, connection }) => (
  <Group key={key}>
    <Label>{field.label || displayName(field.name)}:</Label>
    <Select name={field.name}>
      {connection ? (
        connection.edges.map(({ node }, key) => (
          <Option value={node.client_id} key={key}>
            {node.name}
          </Option>
        ))
      ) : (
        <Option value="" disabled>
          <Loader size="sm" /> Loading...
        </Option>
      )}
    </Select>
  </Group>
)

export default withConnectionQuery({
  graphqlQuery,
  paginated: false,
  namespace: 'products'
})(ProductSelect)



// WEBPACK FOOTER //
// ./src/components/fields/ProductSelect.js